import { connect } from 'react-redux';
import { bindActionCreators } from '../redux';
import {
    showErrorToast, showSuccessToast, showWarningToast,
} from './toasts.state';
import { ToastOpts } from './toasts.types';

export interface WithToastsProps {
    showErrorToast:(params:ToastOpts) => void;
    showSuccessToast:(params:ToastOpts) => void;
    showWarningToast:(params:ToastOpts) => void;
}

export const withToasts = connect(
    null,
    dispatch => bindActionCreators({
        showErrorToast,
        showSuccessToast,
        showWarningToast,
    }, dispatch),
);
